"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StarSmallIcon = void 0;
const react_1 = __importDefault(require("react"));
const StarSmallIcon = (_a) => {
    var { onClick } = _a, props = __rest(_a, ["onClick"]);
    return (react_1.default.createElement("svg", Object.assign({}, props, { onClick: onClick, width: "23", height: "22", viewBox: "0 0 23 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }),
        react_1.default.createElement("path", { d: "M11.5152 0.999939L14.7645 7.58248L22.0305 8.64452L16.7729 13.7654L18.0137 20.9999L11.5152 17.5825L5.01682 20.9999L6.25762 13.7654L1 8.64452L8.26604 7.58248L11.5152 0.999939Z", fill: "white", fillOpacity: "0.2", stroke: "#909EA6", strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.StarSmallIcon = StarSmallIcon;
